export default __webpack_public_path__ + "static/media/ktb-logo.46853ccd.svg";